import { render, staticRenderFns } from "./modelExamScoreQueryList.vue?vue&type=template&id=352969f4&scoped=true"
import script from "./modelExamScoreQueryList.vue?vue&type=script&lang=js"
export * from "./modelExamScoreQueryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352969f4",
  null
  
)

export default component.exports